export default __webpack_public_path__ + "static/media/background-mobile-enterprise.d87d7c55.png";